enum UserRoleEnum {
  AKTY_EU = 'AKTY_EU',
  AKTY_EU_SPRAVCA = 'AKTY_EU_SPRAVCA',
  ODOSIELATEL = 'ODOSIELATEL',
  PRIPOMIENKOVATEL = 'PRIPOMIENKOVATEL',
  VYHODNOCOVATEL = 'VYHODNOCOVATEL',
  VEREJNOST = 'VEREJNOST',
  SUPERADMIN = 'SUPERADMIN',
  NELEGISLATIVNA_ORGANIZACIA = 'NELEGISLATIVNA_ORGANIZACIA',
  PREDKLADATEL_LEG = 'PREDKLADATEL_LEG',
  PREDKLADATEL_NELEG = 'PREDKLADATEL_NELEG',
  PREDKLADATEL_ZODP = 'PREDKLADATEL_ZODP',
  VEDUCI_ORGANIZACIE = 'VEDUCI_ORGANIZACIE'
}

interface UserRole {
  hodnota: UserRoleEnum,
  iamId: string
}

function userRoleId(userRoleEnum: UserRoleEnum): string {
  switch (userRoleEnum) {
    case UserRoleEnum.AKTY_EU:
      return 'Akty EÚ';
    case UserRoleEnum.AKTY_EU_SPRAVCA:
      return 'Akty EÚ - správca';
    case UserRoleEnum.ODOSIELATEL:
      return 'Odosielanie-pripomienok';
    case UserRoleEnum.PRIPOMIENKOVATEL:
      return 'Pripomienkovatel';
    case UserRoleEnum.PREDKLADATEL_LEG:
      return 'Predkladateľ - legislatívny';
    case UserRoleEnum.PREDKLADATEL_NELEG:
      return 'Predkladatel - nelegislatívny';
    case UserRoleEnum.PREDKLADATEL_ZODP:
      return 'Predkladatel-zodpovedny';
    case UserRoleEnum.SUPERADMIN:
      return 'Administrator-WFE';
    case UserRoleEnum.VEDUCI_ORGANIZACIE:
      return 'Administrator-Local';
    case UserRoleEnum.VYHODNOCOVATEL:
      return 'Vyhodnocovatel';
    default:
      throw new Error('Unrecognized user role enum value.');
  }
}

export {
  UserRoleEnum, UserRole, userRoleId,
};
